import { ExclusionItemGridGzDataProvider } from '../dataProvider/ExclusionItemGridGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
export class ExclusionItemGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, ExclusionItemGridGzDataProvider);
  }
}
